import React, { useEffect, useState } from "react";
import api, { errMsg } from "../../core/api";
import ResponsiveList from "../../components/ResponsiveList";
import { useApp } from "../../core/AppContext";
import { formatDate, todayIso } from "../../core/format";
import PrintReport from "../../components/PrintReport";
import { equipmentPrint } from "../../core/printConfigs";
const STATUS_LABEL = { healthy: "سالم", unusable: "غیرقابل استفاده" };

const expiryBadge = (iso) => {
  if (!iso) return <span>—</span>;
  const today = todayIso();
  const diff = new Date(`${iso}T00:00:00Z`) - new Date(`${today}T00:00:00Z`);
  const cls = iso < today ? "bad" : diff <= 5 * 86400000 ? "warn" : "ok";
  const hint = iso < today ? "منقضی شده" : cls === "warn" ? "کمتر از ۳۰ روز" : "";
  return <span className={`badge solid ${cls}`} title={hint}>{formatDate(iso)}</span>;
};

export default function Property() {
  const { toast } = useApp();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
const [printRow, setPrintRow] = useState(null);

  useEffect(() => {
    api
      .get("/equipment/property")
      .then((r) => setRows(r.data.items))
      .catch((e) => toast(errMsg(e), "err"))
      .finally(() => setLoading(false));
  }, [toast]);

  const stBadge = (r) => (
    <span className={`badge ${r.status === "healthy" ? "ok" : "bad"}`}>{STATUS_LABEL[r.status]}</span>
  );

  return (
    <>
      <div className="page-head">
        <div>
          <h2>اموال</h2>
          <p>تجهیزاتی که به‌عنوان اموال ثبت و امضا شده‌اند</p>
        </div>
      </div>
      <ResponsiveList
        loading={loading}
        rows={rows}
        actions={(r) => (
  <button className="icon-btn" title="چاپ گزارش" onClick={() => setPrintRow(r)}><i className="fa-solid fa-print" /></button>
)}
        empty="تجهیزاتی با اموال ثبت نشده است"
        columns={[
          { key: "propertyNo", label: "شماره اموال", render: (r) => <b dir="ltr">{r.propertyNo}</b> },
          { key: "signerName", label: "امضاکننده / تحویل‌گیرنده", render: (r) => r.signerName || "—" },
          { key: "code", label: "کد انبار", render: (r) => <span dir="ltr">{r.code || "—"}</span> },
          { key: "name", label: "نام تجهیزات", render: (r) => <b>{r.name}</b> },
          { key: "kind", label: "نوع تجهیزات" },
          { key: "status", label: "وضعیت", render: stBadge },
          { key: "location", label: "محل نصب / نگهداری" },
          { key: "supervisorName", label: "مسئول محل" },
          { key: "supervisorPhone", label: "شماره تماس مسئول", render: (r) => <span dir="ltr">{r.supervisorPhone || "—"}</span> },
          { key: "expiryDate", label: "انقضا / شارژ بعدی", render: (r) => expiryBadge(r.expiryDate) },
        ]}
        mobileTitle={(r) => r.name}
        mobileBadge={stBadge}
        mobileMeta={(r) => [
          { icon: "fa-solid fa-hashtag", label: "شماره اموال", value: <span dir="ltr">{r.propertyNo}</span> },
          { icon: "fa-solid fa-signature", label: "امضاکننده", value: r.signerName || "—" },
          { icon: "fa-solid fa-barcode", label: "کد انبار", value: <span dir="ltr">{r.code || "—"}</span> },
          { icon: "fa-solid fa-tag", label: "نوع", value: r.kind },
          { icon: "fa-solid fa-location-dot", label: "محل", value: r.location },
          { icon: "fa-regular fa-user", label: "مسئول محل", value: r.supervisorName },
          { icon: "fa-solid fa-phone", label: "تماس", value: <span dir="ltr">{r.supervisorPhone}</span> },
          { icon: "fa-regular fa-calendar", label: "انقضا", value: expiryBadge(r.expiryDate) },
        ]}
      />


      {printRow && <PrintReport {...equipmentPrint(printRow)} onClose={() => setPrintRow(null)} />}
    </>
  );
}